<!-- 规模柱状图 -->
<template>
  <div v-if="!$isEmpty(dataSource)" class="scale-bar-chart">
    <div v-if="isDiffScale" class="alert-tip" @click="$goFundApp">为什么基金规模和净资产不一致？</div>
    <!-- 图表 -->
    <div class="chart-container">
      <canvas :id="chartId" :style="chartSize"></canvas>
    </div>
    <div class="more" @click="$goFundApp">更多规模信息</div>
  </div>
  <div v-else class="bar-empty-content">暂无数据</div>
</template>

<script>
import F2 from '@antv/f2';

export default {

  name: 'scale-bar-chart',

  props: {
    chartId: {
      type: String,
      default: 'bar-chart',
    },
    dataSource: {
      type: Array,
      default: () => [],
    },
    chartSize: {
      type: Object,
      default: () => ({
        width: '100%',
        height: '400px',
      }),
    },
    isDiffScale: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    // showDiffTip() {
    //   const
    // }
  },

  methods: {
    initChart() {
      const chart = new F2.Chart({
        id: this.chartId,
        pixelRatio: window.devicePixelRatio,
        appendPadding: 8,
      });
      console.log('scale-bar-chart', this.dataSource);
      const dataList = this.dataSource.map((item, index) => {
        const barColor = index === this.dataSource.length - 1 ? '#FF6933' : '#FFC94D';
        return { ...item, barColor };
      });
      chart.source(dataList);
      chart.axis('value', false); // 不展示纵坐标轴
      chart.tooltip(false); // 展示提示信息
      chart.legend(false);
      chart.interval()
        .size(24)
        .position('date*value')
        .color('barColor', (color) => color);
      chart.render();
      // 绘制文本
      const offset = -5;
      const canvas = chart.get('canvas');
      const group = canvas.addGroup();
      dataList.forEach((item, index) => {
        const point = chart.getPosition(item);
        group.addShape('text', {
          attrs: {
            x: point.x,
            y: point.y + offset,
            text: item.title || '--',
            fontFamily: 'DINAlternate-Bold',
            fontSize: '12px',
            textAlign: 'center',
            textBaseLine: 'bottom',
            fill: index === dataList.length - 1 ? '#ff4400' : '#333333',
          },
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.scale-bar-chart {
  .alert-tip {
    font-size: 28px;
    color: #008aff;
  }
  .more {
    line-height: 102px;
    font-size: 30px;
    color: #008AFF;
    text-align: center;
  }
}
.bar-empty-content {
  width: 100%;
  height: 300px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  color: #ccc;
}
</style>
